import { useQuery } from '@tanstack/react-query';

import { getAffiliation } from '~/services/AgentHub/AgentService';

export const affiliationQueryKeys = {
  all: ['affiliation'] as const,
  details: () => [...affiliationQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...affiliationQueryKeys.details(), id] as const,
};

interface UseGetAffiliationOptions {
  enabled?: boolean;
}

export function useGetAffiliation(id: string, options: UseGetAffiliationOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: affiliationQueryKeys.detail(id),
    queryFn: async () => {
      return await getAffiliation(id);
    },
    enabled: enabled && !!id,
  });
}
